const config = {
  server: process.env.REACT_APP_API_URL,
  websiteURL: 'https://eclipsera-game.com',
  baseURL: '/api/v1',
  socketURL: process.env.REACT_APP_SOCKET_URL,
  schedulerURL: process.env.REACT_APP_SCHEDULER_URL,
}

export default config
